<mat-dialog-content>
  <lemon-dialog-header> Käyttäjän muutoshistoria </lemon-dialog-header>
  @if (loading()) {
    <div style="text-align: center; padding: 20px">
      <mat-spinner diameter="40"></mat-spinner>
    </div>
  }

  @if (!loading() && historia().length === 0) {
    <div style="padding: 20px; text-align: center; color: #666">Ei historiatietoja</div>
  }

  @if (!loading() && historia().length > 0) {
    <table style="width: 100%; border-collapse: collapse">
      <thead>
        <tr style="border-bottom: 2px solid #ddd; background-color: #f5f5f5">
          <th>Päivitetty</th>
          <th>Päivitti</th>
          <th>Etunimi</th>
          <th>Sukunimi</th>
          <th>Email</th>
          <th>Puhelin</th>
          <th>Aktiivinen</th>
          <th>Roolit</th>
          <th>Features</th>
        </tr>
      </thead>
      <tbody>
        @for (item of historia(); track item) {
          <tr style="border-bottom: 1px solid #eee">
            <td>{{ item.paivitetty.toDate() | date: 'dd.MM.yyyy HH:mm' }}</td>
            <td>{{ item.paivittajanNimi }}</td>
            <td [class.red-text]="item.fieldChanges.etunimi">{{ item.etunimi }}</td>
            <td [class.red-text]="item.fieldChanges.sukunimi">{{ item.sukunimi }}</td>
            <td [class.red-text]="item.fieldChanges.email">{{ item.email }}</td>
            <td [class.red-text]="item.fieldChanges.puhelinnumero">{{ item.puhelinnumero || '-' }}</td>
            <td [class.red-text]="item.fieldChanges.aktiivinen">{{ item.aktiivinen ? 'Kyllä' : 'Ei' }}</td>
            <td style="max-width: 200px">
              @for (rooli of item.roolitViewable; track rooli) {
                <div>
                  <span [class.added-item]="rooli.status === 'added'" [class.removed-item]="rooli.status === 'removed'">
                    {{ rooli.nimi }}
                  </span>
                </div>
              }
            </td>
            <td style="max-width: 200px">
              @for (feature of item.featuresViewable; track feature) {
                <div>
                  <span [class.added-item]="feature.status === 'added'" [class.removed-item]="feature.status === 'removed'">
                    {{ feature.nimi }}
                  </span>
                </div>
              }
            </td>
          </tr>
        }
      </tbody>
    </table>
  }
</mat-dialog-content>

<mat-dialog-actions align="center">
  <button mat-button class="primarybutton" (click)="close()">Sulje</button>
</mat-dialog-actions>
